<ion-footer class="border-top" *ngIf="bottomSheetOpen$ === false">
  <ion-toolbar>
    <div class="row" *ngIf="isDuelRole">
      <div class="col-12 col-md-2"></div>
      <div class="col-12 col-md-8">
        <ion-grid>
          <ion-row>
            <!-- Submit Button -->
            <ion-col *ngIf="canSubmitApartFromTeacher()">
              <button type="button"
                class="btn btn-success btn-sm btn-block d-flex align-items-center justify-content-center"
                [disabled]="!subscriptionStatus" (click)="sendFormForApproval()">
                <i class="fa-solid fa-paper-plane me-1"></i>
                <span>Submit</span>
              </button>
            </ion-col>

            <!-- Revert -->
            <ion-col *ngIf="canRevertApartFromTeacher()">
              <button type="button" class="btn btn-danger btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="rejectForm()">
                <i class="fas fa-backspace me-1"></i> Revert
              </button>
            </ion-col>

            <!-- Forward -->
            <ion-col *ngIf="canForwardApartFromTeacher()">
              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="forwordForm()">
                <i class="fas fa-paper-plane me-1"></i> Forward
              </button>
            </ion-col>

            <!-- Share, Recall, Return -->
            <ion-col>
              <button type="button"
                class="btn btn-outline-info btn-sm btn-block d-flex align-items-center justify-content-center"
                [disabled]="!subscriptionStatus" (click)="formSharing()" *ngIf="canShareApartFromTeacher()">
                <i class="fa-solid fa-share-nodes me-1"></i>
                <span>Share</span>
              </button>

              <button type="button" class="btn btn-outline-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="recallForm()" *ngIf="canRecallApartFromTeacher()">
                <i class="fas fa-arrow-left me-1"></i> Recall
              </button>

              <button type="button" class="btn btn-outline-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="resentForm()" *ngIf="canResentApartFromTeacher()">
                <i class="fas fa-circle-arrow-up me-1"></i> Return
              </button>
            </ion-col>

            <!-- DELETE moved ABOVE save -->
            <ion-col *ngIf="canDeleteForm()">
              <button type="button"
                class="btn btn-outline-danger btn-sm btn-block d-flex align-items-center justify-content-center"
                [disabled]="!subscriptionStatus" (click)="deleteForm()">
                <i class="fas fa-trash me-1"></i>
                <span>Delete</span>
              </button>
            </ion-col>

            <!-- Save / Approve -->
            <ion-col>
              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="submitForm()" *ngIf="canCreateApartFromTeacher()">
                <i class="far fa-save me-1"></i> Save
              </button>

              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="updateForm()" *ngIf="canUpdateApartFromTeacher()">
                <i class="far fa-save me-1"></i> Save
              </button>

              <button type="button" class="btn btn-success btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="approvedForm()" *ngIf="canAproveApartFromTeacher()">
                <i class="fas fa-check-circle me-1"></i> Approve
              </button>

              <div class="for-sm-device">
                <button type="button" class="btn btn-outline-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                  (click)="replicateForm()" *ngIf="canReplicateApartFromTeacher()">
                  <i class="fas fa-copy me-1"></i> Replicate
                </button>
              </div>

              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="submitForApprovalWebC()" *ngIf="canSubmitByWebc()">
                <i class="fa-solid fa-paper-plane me-1"></i> Submit
              </button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="col-12 col-md-2"></div>
    </div>

    <!-- !isDuelRole Section -->
    <div class="row" *ngIf="!isDuelRole">
      <div class="col-12 col-md-2"></div>
      <div class="col-12 col-md-8">
        <ion-grid>
          <ion-row>
            <ion-col *ngIf="canSubmit()">
              <button type="button"
                class="btn btn-success btn-sm btn-block d-flex align-items-center justify-content-center"
                [disabled]="!subscriptionStatus" (click)="sendFormForApproval()">
                <i class="fa-solid fa-paper-plane me-1"></i>
                <span>Submit</span>
              </button>
            </ion-col>

            <ion-col *ngIf="canRevert()">
              <button type="button" class="btn btn-danger btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="rejectForm()">
                <i class="fas fa-backspace me-1"></i> Revert
              </button>
            </ion-col>

            <ion-col *ngIf="canForward()">
              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="forwordForm()">
                <i class="fas fa-paper-plane me-1"></i> Forward
              </button>
            </ion-col>

            <ion-col>
              <button type="button"
                class="btn btn-outline-info btn-sm btn-block d-flex align-items-center justify-content-center"
                [disabled]="!subscriptionStatus" (click)="formSharing()" *ngIf="canShare()">
                <i class="fa-solid fa-share-nodes me-1"></i>
                <span>Share</span>
              </button>

              <button type="button" class="btn btn-outline-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="recallForm()" *ngIf="canRecall()">
                <i class="fas fa-arrow-left me-1"></i> Recall
              </button>

              <button type="button" class="btn btn-outline-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="resentForm()" *ngIf="canResent()">
                <i class="fas fa-circle-arrow-up me-1"></i> Return
              </button>

              <div class="for-sm-device">
                <button type="button" class="btn btn-outline-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                  (click)="replicateForm()" *ngIf="canReplicate()">
                  <i class="fas fa-copy me-1"></i> Replicate
                </button>
              </div>
            </ion-col>

            <!-- DELETE before SAVE -->
            <ion-col *ngIf="canDeleteForm()">
              <button type="button"
                class="btn btn-outline-danger btn-sm btn-block d-flex align-items-center justify-content-center"
                [disabled]="!subscriptionStatus" (click)="deleteForm()">
                <i class="fas fa-trash me-1"></i>
                <span>Delete</span>
              </button>
            </ion-col>

            <ion-col>
              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="submitForm()" *ngIf="canCreate()">
                <i class="far fa-save me-1"></i> Save
              </button>

              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="updateForm()" *ngIf="canUpdate()">
                <i class="far fa-save me-1"></i> Save
              </button>

              <button type="button" class="btn btn-success btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="approvedForm()" *ngIf="canAprove()">
                <i class="fas fa-check-circle me-1"></i> Approve
              </button>

              <button type="button" class="btn btn-info btn-sm btn-block" [disabled]="!subscriptionStatus"
                (click)="submitForApprovalWebC()" *ngIf="canSubmitByWebc()">
                <i class="fa-solid fa-paper-plane me-1"></i> Submit
              </button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div class="col-12 col-md-2"></div>
    </div>
  </ion-toolbar>
</ion-footer>